
const IP_ADDRESS = process.env.REACT_APP_URL_BACKEND;
export const headers = [
  { field: "id", headerName: "ID", width: 70, hidden: true },
  { field: "descripcion", headerName: "Descripcion", width: 230 },
  {
    field: "imagen",
    headerName: "Imagen",
    width: 300,
    renderCell: (params) => (
      <img
        src={`${IP_ADDRESS}${params.row.imagen}`}
        alt="slider"
        style={{
          width: "100%",
          height: "auto",
          maxWidth: "800px",
          maxHeight: "300px",
          objectFit: "cover",
        }}
      />
    ),
  },
  ];
  